<template>
  <CForm ref="uploaimage">
    <Loading v-if="isLoading"></Loading>
    <div v-else>
      <CRow>
        <CCol sm="6">Images here</CCol>
      </CRow>
      <CRow v-if="(partnershipGroupShow === '0' || partnershipGroupShow === null)">
        <CCol sm="3">
          <CInputFile
            ref="fileupload"
            label
            accept="image/*"
            invalid-feedback="Name should be filled"
            required
            @change="onFileChange"
          />

          <CInput
            :type="'hidden'"
            required
            v-model="$v.uploadImageForm.images.$model"
            :is-valid="!$v.uploadImageForm.images.$invalid"
          ></CInput>

          <CButton @click="submitForm" :disabled="$v.uploadImageForm.$invalid" color="success">
            <i class="fa fa-save"></i>
            Accept
          </CButton>&nbsp;
          <CButton @click="removeImage" color="danger">
            <i class="fa fa-remove"></i>
            Remove
          </CButton>
        </CCol>
        <CCol sm="2">
          <div>Preview</div>
          <CCard v-if="partnershipGroup.images === null && uploadImageForm.images !== null">
            <CImg :src="uploadImageForm.images" :thumbnail="true" />
          </CCard>
          <CCard v-else-if="partnershipGroup.images !== null">
            <CImg :src="'https://storage.googleapis.com/isikulkas/'+partnershipGroup.images+'?r='+unixTime" :thumbnail="true" />
          </CCard>
          <CCard v-else>
            <CCardBody>
              <CRow>
                <CCol sm="12">No image</CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CRow v-else>
        <CCol sm="3">
          <CImg v-if="partnershipGroup.images !== null" :src="'https://storage.googleapis.com/isikulkas/'+partnershipGroup.images+'?r='+unixTime" :thumbnail="true" />
        </CCol>
      </CRow>
    </div>
  </CForm>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import { required } from "vuelidate/lib/validators";

export default {
  name: "UploadImage",
  components: { Loading },
  data() {
    return {
      title: "Upload Image",
      items: [],
      uploadImageForm: tableInterfaces.partnership_group,
      isLoading: false,
      image: null,
      activeTab: 0,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1) ) + 0
    };
  },
  props: {
    partnershipGroup: {
      type: [Array, Object],
      default: () => [],
    },
    partnershipGroupShow: {
      type: String,
      default: null
    },
  },
  validations: {
    uploadImageForm: {
      images: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  methods: {
    init: function () {
      this.unixTime = Math.floor(Math.random() * (0 - 9999999999 + 1) ) + 0;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah image ini ?")) {
        this.isLoading = true;
        this.uploadImageForm.id = this.partnershipGroup.id;
        this.uploadImageForm.show = 1;
        this.axios.put("console/partnership/group/update-image", this.uploadImageForm).then((response) => {
          this.showInfoNotification({
            title: "Ubah Image",
            message: response.data.message,
          });
        }).catch((error) => {
          this.expired(error, "Ubah Image");
        }).finally(() => {
          this.isLoading = false;
          this.$router.go(0);
          // let route = this.$route.path.split("/");
          // this.init(route[4]);
        });
      }
    },
    
    onFileChange(e) {
      this.createImage(e[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.uploadImageForm.images = e.target.result;
      };
      console.log(this.uploadImageForm);
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
       if (confirm("Apakah anda ingin menghapus image ini ?")) {
        this.isLoading = true;
        var remove = {'images': this.partnershipGroup.images, 'id': this.partnershipGroup.id};
        this.axios.put("console/partnership/group/remove-image", remove).then((response) => {
          this.$refs.uploaimage.reset();
          this.$refs.fileupload.value = null;
          this.uploadImageForm.images = null;
          this.partnershipGroup.images = null;
        }).catch((error) => {
          this.expired(error, "Ubah Image");
        }).finally(() => {
          this.isLoading = false;
          this.$router.go(0);
        });
      }
    },
  },
  mounted() {},
};
</script>
